import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "clearButton" ]

  connect() {
    this.toggleClearButton()
  }

  toggleClearButton() {
    if (this.inputTarget.value.length > 0) {
      this.clearButtonTarget.classList.remove("is-hidden")
    } else {
      this.clearButtonTarget.classList.add("is-hidden")
    }
  }

  clear() {
    this.inputTarget.value = ""
    this.toggleClearButton()
    this.element.requestSubmit()
  }
}
